import instance from "./api";

export async function uploadImage(file) {
  const formData = new FormData();
  formData.append("image", file);

  const response = await instance.post("/storage/generate-admin-url",formData,{
      headers: {
        "Content-Type": "multipart/form-data",
      }})
    .then((r) =>r.data); 
  return response.publicUrl;
}